import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private requestCount = 0;
  private loadingSignal = signal(false);

  // Readonly signal for components
  readonly isLoading = this.loadingSignal.asReadonly();

  show(): void {
    this.requestCount++;
    this.loadingSignal.set(true);
  }

  hide(): void {
    this.requestCount = Math.max(0, this.requestCount - 1);
    if (this.requestCount === 0) {
      this.loadingSignal.set(false);
    }
  }

  // Force reset (useful for error scenarios)
  reset(): void {
    this.requestCount = 0;
    this.loadingSignal.set(false);
  }
}